
import { defineComponent, ref, onMounted, PropType, computed } from "vue";
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();
import { MdPerson, MdRemove } from "@vicons/ionicons4";
import { useStore, mapGetters } from "vuex";
import { Module, Actions, Getters } from "@/store/enums/homeEnums";
import {
  Module as ParticipationModule,
  Actions as ParticipationActions,
  Getters as ParticipationGetters,
  Params as ParticipationParams
} from "@/store/enums/participationEnums";
import {
  Module as HosterModule,
  Actions as HosterActions,
  Getters as HosterGetters
} from "@/store/enums/hosterEnums";
import { useThemeVars, useDialog } from "naive-ui";
import { changeColor } from "seemly";
import {
  EventStatus as ParamEventStatus,
  ParticapantStatus as ParamParticapantStatus,
  ResponseStatus as ParamResponseStatus,
  IsResolution as ParamIsResolution,
  HasReply as ParamHasReply
} from "@/store/enums/paramsEnums";

import inviteEventModel from "@/core/models/share/inviteEvent.interface";
import voteEventCountModel from "@/core/models/share/voteEventCount.interface";
import voteEventModel from "@/core/models/share/voteEvent.interface";
import invitePersonModel from "@/core/models/share/invitePerson.interface";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "participantModalReplayListSortByStartTime",
  components: {
    MdPerson,
    MdRemove
  },
  props: {
    event: { type: Object as PropType<inviteEventModel | null> }
  },
  setup(props: any, context: any) {
    const store = useStore();
    const { t, locale } = useI18n();
    store.dispatch(
      HosterModule.desc + HosterActions.HandHosterAllData,
      props.event
    );
    const personNone = computed(
      // () => store.getters[HosterModule.desc + HosterGetters.InvitMember]
      function() {
        let ori: Array<invitePersonModel> =
          store.getters[HosterModule.desc + HosterGetters.InvitMember];
        ori = ori.filter(
          (r: invitePersonModel) => r.Status == ParamParticapantStatus.None
        );

        // var result = eventResponse.value.filter((e: voteEventModel) => e.EventScheduleId == eventScheduleId && e.Status != null)
        let name = ori.map((a: invitePersonModel) => a.Name).join(", ");
        let count = ori.length;

        return { name: name, count: count, data: ori };
      }
    );

    const resNone = computed<invitePersonModel>(
      () =>
        store.getters[
          ParticipationModule.desc + ParticipationGetters.EventPartRespStatus
        ]
    );

    const eventResponse = computed<Array<voteEventModel>>(
      () => store.getters[HosterModule.desc + HosterGetters.EventResponse]
    );

    const responseGroupList = computed<
      Array<{ week: string; items: Array<voteEventCountModel> }>
    >(function() {
      // let currentWeek = 0;
      let ori: Array<voteEventCountModel> = store.getters[
        ParticipationModule.desc +
          ParticipationGetters.EventSchedularCountWithMyResponse
      ](ParticipationParams.SortByStartTime);
      // let result: Array<{ week: string; items: Array<voteEventCountModel> }> = [];
      let dayIndexArray: Array<{
        week: string;
        items: Array<voteEventCountModel>;
      }> = [];
      // let idx = -1;
      // let dayIndexArray:any [] = [];
      ori.forEach(item => {
        let dayIndex: string = dayjs( item.ScheduleStartUTCDateTime).format(
          "YYYY-MM-DD"
        );
        let duplicateFlag = false;
        dayIndexArray.forEach(item => {
          if (dayIndex === item["week"]) {
            duplicateFlag = true;
          }
        });
        if (!duplicateFlag) {
          dayIndexArray.push({
            week: dayIndex,
            items: []
          });
        }
      });
      //console.log(dayIndexArray);
      dayIndexArray.forEach((dayIndex, index) => {
        // console.log(dayIndex);
        ori.forEach(item => {
          if (
            dayjs( item.ScheduleStartUTCDateTime).format("YYYY-MM-DD") ===
            dayIndex["week"]
          ) {
            dayIndexArray[index]["items"].push(item);
          }
        });
      });
      return dayIndexArray;
    });

    async function voteNone(resNone: invitePersonModel, status: string) {
      var evntId = resNone.EventHeaderId;
      let param = {
        EventParticipantId: resNone.EventParticipantId,
        Status: status
      };

      await store.dispatch(
        ParticipationModule.desc + ParticipationActions.HandMyEventVoteNone,
        param
      );

      await store.dispatch(
        ParticipationModule.desc +
          ParticipationActions.LoadEventSchedularCountWithMyResponse,
        evntId
      );

      await store.dispatch(
        HosterModule.desc + HosterActions.LoadEventResponse,
        evntId
      );
      await store.dispatch(
        HosterModule.desc + HosterActions.HandHosterAllData,
        props.event
      );
    }

    async function userVote(
      evntId: string,
      timeId: string,
      usrId: string,
      resId: string,
      status: string
    ) {
      let param = {
        EventHeaderId: evntId,
        EventScheduleId: timeId,
        EventParticipantId: usrId,
        ParticipantResponseId: resId,
        Status: status
      };

      await store.dispatch(
        ParticipationModule.desc + ParticipationActions.HandMyEventVote,
        param
      );
      await store.dispatch(
        ParticipationModule.desc +
          ParticipationActions.LoadEventSchedularCountWithMyResponse,
        evntId
      );
      //新增回應時，才會並更回覆狀態
      if (resId == "") {
        store.dispatch(
          Module.desc + Actions.UpdateReloadParticipantEventsFlag,
          true
        );
      }
    }

    function dateDisplay(date: string) {
      return dayjs( date).format("MM/DD ddd");
    }

    function startTimeDisplay(date: string) {
      return dayjs( date).format("HH:mm");
    }

    function endTimeDisplay(date: string) {
      return dayjs( date).format("HHmm") == "0000"
        ? "24:00"
        : dayjs( date).format("HH:mm");
    }

    function percentage(numerator: number, denominator: number) {
      return Number(((numerator * 100) / denominator).toFixed(0));
    }

    function eventResponseFilter(eventScheduleId: string) {
      var result = eventResponse.value.filter(
        (e: voteEventModel) =>
          e.EventScheduleId == eventScheduleId && e.Status != null
      );
      let name = result.map(a => a.Name).join(", ");
      return name;
    }

    onMounted(() => {});

    return {
      ParamResponseStatus,
      ParamParticapantStatus,
      responseGroupList,
      userVote,
      themeVars: useThemeVars(),
      changeColor,
      dateDisplay,
      startTimeDisplay,
      endTimeDisplay,
      percentage,
      voteNone,
      resNone,
      eventResponseFilter,
      personNone,
      t
    };
  }
});
